module.exports = __webpack_public_path__ + "static/media/Icon_menu_story.5c94b9d3.svg";